import { useRef } from 'react'

export interface Indexer<T> {
  addAndGetIndex: (el: T) => number
  getByIndex: (index: number) => T | null
}

const useIndexer = <T>(): Indexer<T> => {
  const mapElementsToIndexRef = useRef<Map<T, number>>(new Map())
  const elementsListRef = useRef<T[]>([])

  const addAndGetIndex = (el: T): number => {
    const index = mapElementsToIndexRef.current.get(el)
    if (index !== undefined) {
      return index
    }
    const newIndex = elementsListRef.current.push(el) - 1
    mapElementsToIndexRef.current.set(el, newIndex)
    return newIndex
  }

  const getByIndex = (index: number): T | null => {
    return elementsListRef.current[index] ?? null
  }

  return {
    addAndGetIndex,
    getByIndex,
  }
}

export default useIndexer
